import { motion } from "framer-motion";

export const PageHeader = ({ eyebrow, title, description, actions }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="mb-8 flex flex-col justify-between gap-4 md:flex-row md:items-end"
    >
      <div>
        {eyebrow && (
          <span
            className="text-xs font-bold uppercase tracking-[0.2em]"
            style={{ color: "var(--accent-primary)" }}
          >
            {eyebrow}
          </span>
        )}
        <h1 className="mt-1.5 font-heading text-3xl font-bold tracking-tight text-[#14245F] md:text-4xl">
          {title}
        </h1>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-[#5A6B8C] md:text-base">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="flex items-center gap-3">{actions}</div>}
    </motion.div>
  );
};
